import { supabase } from '../supabaseClient';

export const challengeService = {
  async getChallengeData(editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id, year')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data: mainData, error: mainDataError } = await supabase
        .from('challenge_data')
        .select('*')
        .eq('edition_id', edition.id)
        .single();

      if (mainDataError && mainDataError.code !== 'PGRST116') throw mainDataError;

      const { data: members } = await supabase
        .from('challenge_members')
        .select('*')
        .eq('edition_id', edition.id)
        .order('display_order');

      return {
        main: mainData || {
          title_override: '',
          subtitle: 'JEUNES ET ETUDIANTS',
          motto: 'Excellence – Innovation – Collaboration',
          objective: 'Le GSIDA Academic Challenge vise à stimuler l’excellence scientifique des jeunes et étudiants, la créativité et la diffusion des connaissances à travers des activités interdisciplinaires et collaboratives.',
          categories: 'Doctorants– Interventions individuelles ou en binôme.',
          criteria_quality: 40,
          criteria_clarity: 30,
          criteria_social: 30,
          prizes: 'Trophée GSIDA 2025, Certificat officiel pour chaque membre gagnant, Mise en avant sur le site et communiqué de presse GSIDA',
          competition_spirit: 'Une compétition bienveillante, fondée sur le partage, l’éthique et la collaboration scientifique. Toute forme de plagiat ou de comportement non éthique entraînera l’exclusion immédiate.',
          hashtag: '#GSIDA' + edition.year,
          footer_image_url: '',
          footer_pdf_url: '',
          is_visible: true
        },
        members: members || [],
        editionYear: edition.year
      };
    } catch (error) {
      console.error('Error getting challenge data:', error);
      throw error;
    }
  },

  async updateChallengeData(data, editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const updateData = {
        ...data,
        edition_id: edition.id,
        updated_at: new Date().toISOString()
      };
      delete updateData.id;

      const { data: existingData } = await supabase
        .from('challenge_data')
        .select('id')
        .eq('edition_id', edition.id)
        .single();

      if (existingData) {
        const { error } = await supabase
          .from('challenge_data')
          .update(updateData)
          .eq('id', existingData.id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('challenge_data')
          .insert([updateData]);
        if (error) throw error;
      }
    } catch (error) {
      console.error('Error updating challenge data:', error);
      throw error;
    }
  },

  async addMember(member, editionYear) {
    try {
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) throw new Error(`Edition ${editionYear} not found`);

      const { data, error } = await supabase
        .from('challenge_members')
        .insert([{ ...member, edition_id: edition.id }])
        .select()
        .single();
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error adding challenge member:', error);
      throw error;
    }
  },

  async updateMember(member) {
    try {
      const { data, error } = await supabase
        .from('challenge_members')
        .update({
          ...member,
          updated_at: new Date().toISOString()
        })
        .eq('id', member.id)
        .select()
        .single();
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating challenge member:', error);
      throw error;
    }
  },

  async deleteMember(id) {
    try {
      const { error } = await supabase
        .from('challenge_members')
        .delete()
        .eq('id', id);
      if (error) throw error;
    } catch (error) {
      console.error('Error deleting challenge member:', error);
      throw error;
    }
  },
  
  async updateMembersOrder(members) {
    try {
      const updates = members.map(m => 
        supabase
          .from('challenge_members')
          .update({ display_order: m.display_order, updated_at: new Date().toISOString() })
          .eq('id', m.id)
      );
      await Promise.all(updates);
    } catch (error) {
      console.error('Error updating challenge members order:', error);
      throw error;
    }
  }
};
